var XPortal = XPortal || {};
XPortal.CustomEvents = (function () {
    const helpers = {
        async HDT_UpdateSLATimesFromProjectSLA(context, action, next) {
            const changedValue = 'Priority';
            const supportContactFld = 'PortalProjectNo';
            const entityName = 'HelpDeskTicket';

            if (!context || !action) return console.warn(`event to [update sla times from project sla] called incorrectly`, 1);
            if ((!context.isOneOfFields(action, changedValue) && !context.isOneOfFields(action, supportContactFld)) || !context.isForEntity(entityName)) return;

            const bfrMdfEnt = XPortal.Store.GetModelByName(action.model).entity;
            const dBfrChangedVl = getObjValue(bfrMdfEnt, changedValue);
            const dBfrContactId = getObjValue(bfrMdfEnt, supportContactFld);

            next(action);
            action.preventDefault = true;

            const aftMdfEntity = XPortal.Store.GetModelByName(action.model).entity;
            const dAftChangedVl = getObjValue(aftMdfEntity, changedValue);
            const dAftContactId = getObjValue(aftMdfEntity, supportContactFld);
            if (dBfrChangedVl === dAftChangedVl && dBfrContactId === dAftContactId) return;
            if (dAftChangedVl === '') {
                dispatchIfDiff(action.model, aftMdfEntity, { SLAResponseTime: '', SLAResolutionTime: '' }, 'SLAResponseTime', 'SLAResponseTime');
                dispatchIfDiff(action.model, aftMdfEntity, { SLAResponseTime: '', SLAResolutionTime: '' }, 'SLAResolutionTime', 'SLAResolutionTime');
                return;
            }

            const xQuery = context.getQuery('No', '=', aftMdfEntity[supportContactFld.toLowerCase()]);
            const projects = await context.RelatedData.Project(xQuery);
            if (projects.length < 1) return console.warn('No matching item found', 3, dAftChangedVl, projects);
            if (projects.length > 1) return console.warn('Multiple results -> cannot handle', 2, dAftChangedVl, projects);
            const project = projects[0];

            // mapping from project to sla
            const map = getSlaFieldMapByPriority(dAftChangedVl);
            const finalResponse = project[map.responseField] ? project[map.responseField] : '';
            const finalResolution = project[map.resolutionField] ? project[map.resolutionField] : '';

            dispatchIfDiff(action.model, aftMdfEntity, { SLAResponseTime: finalResponse }, 'SLAResponseTime', 'SLAResponseTime');
            dispatchIfDiff(action.model, aftMdfEntity, { SLAResolutionTime: finalResolution }, 'SLAResolutionTime', 'SLAResolutionTime');
        },
    };

    function getSlaFieldMapByPriority(priorityRaw) {
        const p = Number(priorityRaw);
        if (isNaN(p)) return null;

        // response fields
        const resp = {
            1: 'AgreedResponseTimeCriticalUrgency',
            2: 'AgreedResponseTimeHighUrgency',
            3: 'AgreedResponseTimeNormalUrgency',
            4: 'AgreedResponseTimeLowUrgency'
        };

        // resolution fields
        const resol = {
            1: 'CriticalAnalysisTime',
            2: 'HighAnalysisTime',
            3: 'MaxAnalysisTime',
            4: 'MinAnalysisTime'
        };

        if (!resp[p] || !resol[p]) return null;
        return { responseField: resp[p].toLowerCase(), resolutionField: resol[p].toLowerCase() };
    }

    function safeToString(v) {
        if (v === null || v === undefined) return '';
        const s = String(v).trim();
        return s;
    }

    function getObjValue(entity, field) {
        for (let curField of entity.Fields) {
            if (curField.Name.toLowerCase() == field.toLowerCase()) return curField.StringValue;
        }
    }

    function dispatchIfDiff(modelName, curData, srcData, cFname, sFname) {
        var cval = XPortal.Template.GetObjPropValueByName(curData || {}, cFname);
        var sval = XPortal.Template.GetObjPropValueByName(srcData || {}, sFname);
        if (cval != sval) XPortal.Store.DispatchByName(modelName, cFname, sval, false, true);
    }

    //register events in repository
    function waitFor(onAction, onFalse) { if (!onAction()) { setTimeout(function () { onFalse(onAction, onFalse); }, 100); } };
    waitFor(function () { if (XPortal["Events"] && XPortal["Events"]["helpers"]) { for (var i in helpers) XPortal.Events.helpers[i] = helpers[i]; return true; } else return false; }, waitFor);
    //end of registration
    return helpers;
})();
